// ===== RESPONSABLE FORMATION =====
import CampagneFormModal from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneFormModal";
import CatalogueManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/CatalogueManagement";
import CapsuleManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/CapsuleManagement";
import FormationManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/FormationManagement";
import MoocManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/MoocManagement";
import ParamDomainesThemes from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ParamDomainesThemes";
import SalleManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/SalleManagement";
import ConsolidationDemandes from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ConsolidationDemandes";
import DemanderFormationRf from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/DemanderFormationRf";
import TraitementDemandesRf from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/TraitementDemandesRf";
import FournisseurManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/FournisseurManagement";
import ConsultantManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ConsultantManagement";
import ModuleCleManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/moduleCle/ModuleCleManagement";
import EventManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/events/EventManagement";
import EventAbsenceManagementPage from "../app/modules/Formation/ResponsableFormation/RessourcesJs/events/EventAbsenceManagementPage";
import LmsGlobalReportingPage from "../app/modules/Formation/ResponsableFormation/RessourcesJs/lms/LmsGlobalReportingPage";
import ScormProgressReportPage from "../app/modules/Formation/ResponsableFormation/RessourcesJs/scorm/ScormProgressReportPage";
import FormationDynamicDashboardPage from "../app/modules/Formation/Dashboards/FormationDynamicDashboardPage";
import ModuleCleContentsManagement from "../app/modules/contenuModule/pages/ModuleCleContentsManagement";
import MesModulesPage from "../app/modules/Formation/Apprenant/MesModulesPage";
import ModulePlayerPage from "../app/modules/Formation/Apprenant/ModulePlayerPage";
import ModulePersonalNotesPage from "../app/modules/Formation/Apprenant/ModulePersonalNotesPage";
import SallesVirtuellesPage from "../app/modules/Formation/Apprenant/SallesVirtuellesPage";

// ===== MANAGER =====
import DemanderFormationManager from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/DemanderFormationManager";
import TraitementDemandesManager from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/TraitementDemandesManager";

import CampagneManagement
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneManagement";
import EvaluationsManagement from "../app/modules/Evaluations/EvaluationsManagement";
import CalendarPage from "../app/modules/calendar/pages/CalendarPage";
import CertificatManagement
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/certificats/CertificatManagement";
import MesDemandesCollaborateur
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/MesDemandesCollaborateur";
import BookmarksCollaborateur
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/BookmarksCollaborateur";
import BookmarksManager
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/BookmarksManager";
import QuizManagement from "../app/modules/QuizAndQuestions/QuizManagement";
import QuestionManagement from "../app/modules/QuizAndQuestions/QuestionManagement";
import DemandesCollaborateur
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/DemandesCollaborateur";

export const FormationRoutes  = [

    // ===== RESPONSABLE DASHBOARD =====
    { path: "/formation/dashboard", element: <FormationDynamicDashboardPage /> },
    { path: "/formation/dashboard/responsable", element: <FormationDynamicDashboardPage /> },
    { path: "/formation/dashboard/manager", element: <FormationDynamicDashboardPage /> },
    { path: "/formation/dashboard/collaborateur", element: <FormationDynamicDashboardPage /> },

    // ===== CAMPAGNES =====
    { path: "/formation/responsable/campagnes", element: <CampagneManagement /> },
    { path: "/formation/responsable/campagnes/add", element: <CampagneFormModal /> },
    { path: "/formation/responsable/campagnes/:id/edit", element: <CampagneFormModal /> },

    { path: "/formation/responsable/catalogues", element: <CatalogueManagement /> },

    { path: "/formation/responsable/capsules", element: <CapsuleManagement /> },

    { path: "/formation/responsable/mooc", element: <MoocManagement /> },
    { path: "/formations/mooc", element: <MoocManagement /> },
    { path: "/formation/responsable/formations", element: <FormationManagement /> },
    { path: "/formation/responsable/domaines-themes", element: <ParamDomainesThemes /> },
    { path: "/formation/responsable/salles", element: <SalleManagement /> },
    { path: "/formation/responsable/certificats", element: <CertificatManagement /> },
    { path: "/formation/responsable/fournisseurs", element: <FournisseurManagement /> },
    { path: "/formation/responsable/consultants", element: <ConsultantManagement /> },
    { path: "/formation/responsable/modules", element: <ModuleCleManagement moduleContext="FORMATION" /> },
    { path: "/formation/responsable/modules/:moduleCleId/contents", element: <ModuleCleContentsManagement /> },
    { path: "/formation/responsable/modules/:moduleId/lms/reporting", element: <LmsGlobalReportingPage /> },
    { path: "/formation/responsable/modules/:moduleId/scorm/progress", element: <ScormProgressReportPage /> },
    { path: "/formation/responsable/evenements", element: <EventManagement /> },
    { path: "/formation/responsable/evenements/:eventId/absences", element: <EventAbsenceManagementPage /> },
    { path: "/formation/responsable/evaluations", element: <EvaluationsManagement /> },
    { path: "/agenda", element: <CalendarPage /> },
    { path: "/formation/quizzes", element: <QuizManagement moduleContext="FORMATION" /> },
    { path: "/quizzes", element: <QuizManagement /> },
    { path:"/quizzes/:quizId/questions", element: <QuestionManagement />},
    { path:"/formation/quizzes/:quizId/questions", element: <QuestionManagement />},


    // ===== DEMANDES RESPONSABLE =====
    { path: "/formation/responsable/consolidation", element: <ConsolidationDemandes /> },
    { path: "/formation/responsable/demande", element: <DemanderFormationRf /> },
    { path: "/formation/responsable/demande/traitement", element: <TraitementDemandesRf /> },

    // ===== MANAGER =====
    { path: "/formation/manager/demande", element: <DemanderFormationManager /> },
    { path: "/formation/manager/bookmarks", element: <BookmarksManager /> },
    { path: "/formation/manager/demande/traitement", element: <TraitementDemandesManager /> },

    // ===== APPRENANT =====
    { path: "/formation/apprenant/demande", element: <DemandesCollaborateur /> },
    { path: "/formation/apprenant/mes-demandes", element: <MesDemandesCollaborateur /> },
    { path: "/formation/apprenant/modules", element: <MesModulesPage /> },
    { path: "/formation/apprenant/salles", element: <SallesVirtuellesPage /> },
    { path: "/formation/apprenant/salles-virtuelles", element: <SallesVirtuellesPage /> },
    { path: "/formation/apprenant/modules/:moduleId/player", element: <ModulePlayerPage /> },
    { path: "/formation/apprenant/modules/:moduleId/notes", element: <ModulePersonalNotesPage /> },
    { path: "/formation/apprenant/bookmarks", element: <BookmarksCollaborateur /> }

];
